import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { MasterDataType } from "@type/HRM/master-data";

const apiEndPoint = `${process.env.REACT_APP_MASTER_DATA_SERVICE_URL}${process.env.REACT_APP_MASTER_DATA_PORT}/${process.env.REACT_APP_MASTER_DATA_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.GET_MASTER_DATA}`;

export const getMasterData = (() => {
  return async (
    id: string,
    queryParams?: Record<string, any>,
  ): Promise<{ data: MasterDataType[] | unknown }> => {
    return api
      .get(`${apiEndPoint}/${id}`, { params: queryParams })
      .then((response) => {
        return { data: response.data.data };
      });
  };
})();
